import axios from "../axios/index.js";

const urlGetUserList = "/api/user/get-user";
const urlGetAdminAuth = "/api/get-admin-auth";

export default {
    getUser() {
        return axios.get(urlGetUserList);
    },

    getAdminAuth() {
        return axios.post(urlGetAdminAuth);
    },
};
